import React, { useState } from 'react';
import InfoNote from 'new-ui/Components/InfoNote';
import { useTranslation } from 'utils/modifiedTranslation';
// eslint-disable-next-line import/no-cycle
import { SearchSelect } from './SearchSelect/SearchSelect';

export const DrugsReceivedSearchSelect = (props) => {
  const { t } = useTranslation();
  const [selectedOptionValues, setSelectedOptionValues] = useState([]);
  return (
    <SearchSelect
      {...props}
      onChange={setSelectedOptionValues}
      infoNote={(selectedOptionValues.length > 1) && <InfoNote info={t('intake.note_description')} />}
    />
  );
};
